import { render } from "./S135138.vue?vue&type=template&id=87019686"
const script = {}
script.render = render

export default script